export default {
  'coupon.error_code.E0009': 'คูปองนี้หมดอายุแล้ว',
  'coupon.error_code.E0010': 'คูปองนี้ถูกรับครบจำนวนแล้ว',
  'coupon.error_code.E0011': 'คุณได้รับคูปองนี้แล้ว',
  'coupon.error_code.E0012': 'คูปองนี้ถูกโอนแล้ว กรุณาให้เพื่อนรับคูปอง',
  'coupon.error_code.E0013': 'คูปองนี้หมดอายุและไม่สามารถรับได้',
  'coupon.error_code.E0014': 'เลยระยะเวลาการรับคูปองแล้ว',
  'coupon.error_code.E0015': 'ขออภัย เพื่อนของคุณยกเลิกการโอนคูปองแล้ว',
  'coupon.error_code.E0016': 'ข้อมูลคูปองผิดปกติ รับคูปองไม่สำเร็จ',
  'coupon.error_code.E0017': 'แต้มไม่เพียงพอ ไม่สามารถแลกได้',
  'coupon.error_code.E0018': 'ไม่ถึงเกณฑ์การได้รับแต้ม',
  'coupon.error_code.E0019': 'ขออภัย ระดับสมาชิกของคุณยังไม่เข้าเงื่อนไขการรับคูปอง',
  'coupon.error_code.E0020': 'คูปองนี้เลยกำหนดเวลาการรับแล้ว',
  'coupon.error_code.E0021': 'รับแต้มโปรโมชั่นไม่สำเร็จ',
  'coupon.error_code.E0022': 'คูปองนี้จะเปิดให้รับตั้งแต่ {start} ถึง {end}',
  'coupon.error_code.E0023': 'คูปองนี้ถูกลบแล้ว',
  'coupon.error_code.E0024': 'ได้รับคูปองไม่สำเร็จ',
  'coupon.error_code.default': 'รับคูปองไม่สำเร็จ',
  'coupon.collect.success.coupon': 'ได้รับคูปอง',
  'coupon.collect.success.point': 'ได้รับแต้ม',
} as Record<string, string>;
